export interface Currency {
  symbol: string
  label: string
  code: string
}

export const currencies: Record<string, Currency> = {
  NZD: {
    symbol: '$',
    label: 'New Zealand Dollars',
    code: 'NZD'
  }
}
